import { default as ComponentChecks } from './component.checks';
import { default as LinesheetChecks } from './linesheet.checks';
import { default as MaterialChecks } from './material.checks';
import { default as ProductChecks } from './product.checks';

export interface CheckList<DataType> {
  title: string;
  meta?: {
    [key: string]: any;
  };
  isComplete(data: DataType): boolean;
}

export default <T>(checklist: Array<CheckList<T>>, dataset: T) => {
  let completedItems = 0;
  const list = checklist.map(item => {
    const isComplete = item.isComplete(dataset);
    completedItems += isComplete ? 1 : 0;
    return {
      ...item,
      isComplete,
    };
  });
  const progress = Math.floor((completedItems / list.length) * 100);

  return {
    list,
    progress,
  };
};

export {
  ComponentChecks,
  LinesheetChecks,
  MaterialChecks,
  ProductChecks,
};
